/* ─── Shared Comic / Pop-Art utilities ─── */

/** Inline SVG Ben-Day dot pattern as CSS background-image value */
export const benDayPattern = (color: string, size = 4, gap = 8) =>
  `url("data:image/svg+xml,%3Csvg width='${gap}' height='${gap}' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='${gap / 2}' cy='${gap / 2}' r='${size / 2}' fill='${encodeURIComponent(color)}' /%3E%3C/svg%3E")`;

/** Standard comic colors */
export const COMIC_COLORS = {
  deepBlue: "#0A1F44",
  yellow: "#FFE156",
  orange: "#FF6B35",
  red: "#E63946",
  cyan: "#00B4D8",
  purple: "#9B5DE5",
  teal: "#00F5D4",
  pink: "#F15BB5",
  white: "#FFFFFF",
} as const;

/** Comic font stack */
export const COMIC_FONT = "'Bangers', 'Impact', 'Arial Black', sans-serif";

/** Standard comic border + shadow classes */
export const COMIC_BORDER = "border-[3px] border-black";
export const COMIC_BORDER_THICK = "border-[4px] border-black";
export const COMIC_SHADOW = "shadow-[4px_4px_0_0_rgba(0,0,0,1)]";
export const COMIC_SHADOW_LG = "shadow-[6px_6px_0_0_rgba(0,0,0,1)]";

/** Color palette for cycling through tiles/cards */
export const COMIC_PALETTE = [
  { bg: "#FFE156", dot: "rgba(0,0,0,0.07)", text: "text-amber-900" },
  { bg: "#FF6B35", dot: "rgba(255,255,255,0.12)", text: "text-orange-950" },
  { bg: "#00B4D8", dot: "rgba(255,255,255,0.1)", text: "text-sky-950" },
  { bg: "#9B5DE5", dot: "rgba(255,255,255,0.08)", text: "text-purple-950" },
  { bg: "#00F5D4", dot: "rgba(0,0,0,0.06)", text: "text-teal-900" },
  { bg: "#F15BB5", dot: "rgba(255,255,255,0.1)", text: "text-pink-950" },
  { bg: "#E63946", dot: "rgba(255,255,255,0.1)", text: "text-red-950" },
] as const;
